import { DatabaseFieldType } from '@databases/types/database';
import { type ReactNode } from 'react';
import { createContentColumnFieldReadModule } from '../content-column-field-read-module.ts';
import { type ContentColumnReadPolicy } from '../content-column-read.ts';
import {
  EMPTY_PAGE_DETAILS_CONTENT,
  type PageDetailsReadContent
} from './page-details-read-content.ts';

export type PageDetailsReadPolicy = ContentColumnReadPolicy;
export type PageDetailsReadRenderer = (content: PageDetailsReadContent) => ReactNode;

/**
 * Compiles the configured detail column through the shared V1 content-column rules.
 */
export function createPageDetailsFieldReadModule(
  options?: PageDetailsReadPolicy & { readonly render?: PageDetailsReadRenderer }
) {
  return createContentColumnFieldReadModule(
    {
      fieldType: DatabaseFieldType.PAGE_DETAILS,
      emptyContent: EMPTY_PAGE_DETAILS_CONTENT,
      getColumn: (field) => field.settings.contentField
    },
    options
  );
}
